export const REQUEST_SET_PRIVILEGES_MANAGER = 'REQUEST_SET_PRIVILEGES_MANAGER';

export const ROLES_MANAGER = [
  'Gestionnaire consultation',
  'Gestionnaire judiciaire',
  'Gestionnaire suivi judiciaire',
  'Manager',
  'Gestionnaire ouverture',
  'Gestionnaire pré-ouverture',
  'Solh/Flhin',
  'Gestionnaire transaction',
  'Gestionnaire dossier important',
];

export const MAPPED_ROLES_MANAGER = {
  isConsultationManager: 'Gestionnaire consultation',
  isCourtManager: 'Gestionnaire judiciaire',
  isCourtMonitoringManager: 'Gestionnaire suivi judiciaire',
  isManager: 'Manager',
  isOpeningManager: 'Gestionnaire ouverture',
  isPreOpenManager: 'Gestionnaire pré-ouverture',
  isSolhFlhin: 'Solh/Flhin',
  isTransactionManager: 'Gestionnaire transaction',
  isPriorityClaimsManager: 'Gestionnaire dossier important',
};
